import React, { useEffect } from "react";
import { TimeRangePicker  } from 'rsuite';
import "rsuite/dist/rsuite-no-reset.min.css"; 

type TimeRangePickerProps = {
    errors?: { startHour?: boolean };
    strings?: { form?: { pickupLocation?: { time?: string } } };
    onChange?: (startTime: string | null, endTime: string | null) => void;
    value?: [string | null, string | null]; 
    hideHours?: (hour: number) => boolean;
    hideMinutes?: (minute: number) => boolean;
};

const TimeRangePickerWrapper: React.FC<TimeRangePickerProps> = ({
    errors = {},
    onChange,
    value,
    hideHours,
    hideMinutes,
}) => {

    useEffect(() => {
        const style = document.createElement('style');
        style.textContent = `
            .rs-picker-popup {
                z-index: 9999 !important;
            }
            
            /* Light mode styles (default) */
            .rs-picker {
                background-color: white !important;
                color: rgb(17 24 39) !important;
            }
            
            .rs-input-group {
                background-color: white !important;
                border-color: rgb(209 213 219) !important;
            }
            
            .rs-input {
                background-color: white !important;
                color: rgb(17 24 39) !important;
                border-color: rgb(209 213 219) !important;
            }
            
            .rs-input::placeholder {
                color: rgb(107 114 128) !important;
            }
            
            .rs-input-group-addon {
                background-color: white !important;
                border-color: rgb(209 213 219) !important;
                color: rgb(17 24 39) !important;
            }

            .rs-picker-popup-daterange,
            .rs-picker-daterange-panel,
            .rs-calendar,
            .rs-calendar-time-dropdown,
            .rs-calendar-time-dropdown-content,
            .rs-calendar-time-dropdown-column {
                background-color: white !important;
            }

            .rs-calendar-time-dropdown-column-title {
                background-color: white !important;
                color: rgb(17 24 39) !important;
                border-bottom-color: rgb(209 213 219) !important;
            }

            .rs-calendar-time-dropdown-cell {
                color: rgb(17 24 39) !important;
            }

            .rs-calendar-time-dropdown-cell:hover {
                background-color: rgb(243 244 246) !important;
            }

            .rs-calendar-time-dropdown-cell-active {
                background-color: rgb(59 130 246) !important;
                color: white !important;
            }

            .rs-picker-toolbar {
                background-color: white !important;
                border-top-color: rgb(209 213 219) !important;
            }

            .rs-btn-primary {
                background-color: rgb(59 130 246) !important;
                border-color: rgb(59 130 246) !important;
                color: white !important;
            }
            
            /* Dark mode styles */
            .dark .rs-picker,
            [data-theme="dark"] .rs-picker,
            html.dark .rs-picker,
            body.dark .rs-picker,
            html[data-theme="dark"] .rs-picker {
                background-color: rgb(55 65 81) !important;
                color: white !important;
            }
            
            .dark .rs-input-group,
            [data-theme="dark"] .rs-input-group,
            html.dark .rs-input-group,
            body.dark .rs-input-group,
            html[data-theme="dark"] .rs-input-group {
                background-color: rgb(55 65 81) !important;
                border-color: rgb(75 85 99) !important;
            }
            
            .dark .rs-input,
            [data-theme="dark"] .rs-input,
            html.dark .rs-input,
            body.dark .rs-input,
            html[data-theme="dark"] .rs-input {
                background-color: rgb(55 65 81) !important;
                color: white !important;
                border-color: rgb(75 85 99) !important;
            }
            
            .dark .rs-input::placeholder,
            [data-theme="dark"] .rs-input::placeholder,
            html.dark .rs-input::placeholder,
            body.dark .rs-input::placeholder,
            html[data-theme="dark"] .rs-input::placeholder {
                color: rgb(156 163 175) !important;
            }
            
            .dark .rs-input-group-addon,
            [data-theme="dark"] .rs-input-group-addon,
            html.dark .rs-input-group-addon,
            body.dark .rs-input-group-addon,
            html[data-theme="dark"] .rs-input-group-addon {
                background-color: rgb(55 65 81) !important;
                border-color: rgb(75 85 99) !important;
                color: white !important;
            }

            .dark .rs-picker-popup-daterange,
            [data-theme="dark"] .rs-picker-popup-daterange,
            html.dark .rs-picker-popup-daterange,
            body.dark .rs-picker-popup-daterange,
            html[data-theme="dark"] .rs-picker-popup-daterange {
                background-color: rgb(55 65 81) !important;
                border-color: rgb(75 85 99) !important;
                color: white !important;
            }

            .dark .rs-picker-daterange-panel,
            [data-theme="dark"] .rs-picker-daterange-panel,
            html.dark .rs-picker-daterange-panel,
            body.dark .rs-picker-daterange-panel,
            html[data-theme="dark"] .rs-picker-daterange-panel {
                background-color: rgb(55 65 81) !important;
            }

            .dark .rs-calendar,
            [data-theme="dark"] .rs-calendar,
            html.dark .rs-calendar,
            body.dark .rs-calendar,
            html[data-theme="dark"] .rs-calendar {
                background-color: rgb(55 65 81) !important;
                color: white !important;
            }

            .dark .rs-calendar-time-dropdown,
            [data-theme="dark"] .rs-calendar-time-dropdown,
            html.dark .rs-calendar-time-dropdown,
            body.dark .rs-calendar-time-dropdown,
            html[data-theme="dark"] .rs-calendar-time-dropdown {
                background-color: rgb(55 65 81) !important;
            }

            .dark .rs-calendar-time-dropdown-content,
            [data-theme="dark"] .rs-calendar-time-dropdown-content,
            html.dark .rs-calendar-time-dropdown-content,
            body.dark .rs-calendar-time-dropdown-content,
            html[data-theme="dark"] .rs-calendar-time-dropdown-content {
                background-color: rgb(55 65 81) !important;
            }

            .dark .rs-calendar-time-dropdown-column,
            [data-theme="dark"] .rs-calendar-time-dropdown-column,
            html.dark .rs-calendar-time-dropdown-column,
            body.dark .rs-calendar-time-dropdown-column,
            html[data-theme="dark"] .rs-calendar-time-dropdown-column {
                background-color: rgb(55 65 81) !important;
            }

            .dark .rs-calendar-time-dropdown-column-title,
            [data-theme="dark"] .rs-calendar-time-dropdown-column-title,
            html.dark .rs-calendar-time-dropdown-column-title,
            body.dark .rs-calendar-time-dropdown-column-title,
            html[data-theme="dark"] .rs-calendar-time-dropdown-column-title {
                background-color: rgb(55 65 81) !important;
                color: white !important;
                border-bottom-color: rgb(75 85 99) !important;
            }

            .dark .rs-calendar-time-dropdown-cell,
            [data-theme="dark"] .rs-calendar-time-dropdown-cell,
            html.dark .rs-calendar-time-dropdown-cell,
            body.dark .rs-calendar-time-dropdown-cell,
            html[data-theme="dark"] .rs-calendar-time-dropdown-cell {
                color: white !important;
                background-color: transparent !important;
            }

            .dark .rs-calendar-time-dropdown-cell:hover,
            [data-theme="dark"] .rs-calendar-time-dropdown-cell:hover,
            html.dark .rs-calendar-time-dropdown-cell:hover,
            body.dark .rs-calendar-time-dropdown-cell:hover,
            html[data-theme="dark"] .rs-calendar-time-dropdown-cell:hover {
                background-color: rgb(75 85 99) !important;
                color: white !important;
            }

            .dark .rs-calendar-time-dropdown-cell-active,
            [data-theme="dark"] .rs-calendar-time-dropdown-cell-active,
            html.dark .rs-calendar-time-dropdown-cell-active,
            body.dark .rs-calendar-time-dropdown-cell-active,
            html[data-theme="dark"] .rs-calendar-time-dropdown-cell-active {
                background-color: rgb(59 130 246) !important;
                color: white !important;
            }

            .dark .rs-scroll-view,
            [data-theme="dark"] .rs-scroll-view,
            html.dark .rs-scroll-view,
            body.dark .rs-scroll-view,
            html[data-theme="dark"] .rs-scroll-view {
                background-color: rgb(55 65 81) !important;
            }

            .dark .rs-picker-toolbar,
            [data-theme="dark"] .rs-picker-toolbar,
            html.dark .rs-picker-toolbar,
            body.dark .rs-picker-toolbar,
            html[data-theme="dark"] .rs-picker-toolbar {
                background-color: rgb(55 65 81) !important;
                border-top-color: rgb(75 85 99) !important;
            }

            .dark .rs-btn-primary,
            [data-theme="dark"] .rs-btn-primary,
            html.dark .rs-btn-primary,
            body.dark .rs-btn-primary,
            html[data-theme="dark"] .rs-btn-primary {
                background-color: rgb(59 130 246) !important;
                border-color: rgb(59 130 246) !important;
                color: white !important;
            }
            
            @media (prefers-color-scheme: dark) {
                .rs-picker {
                    background-color: rgb(55 65 81) !important;
                    color: white !important;
                }
                
                .rs-input-group {
                    background-color: rgb(55 65 81) !important;
                    border-color: rgb(75 85 99) !important;
                }
                
                .rs-input {
                    background-color: rgb(55 65 81) !important;
                    color: white !important;
                    border-color: rgb(75 85 99) !important;
                }
                
                .rs-input::placeholder {
                    color: rgb(156 163 175) !important;
                }
                
                .rs-input-group-addon {
                    background-color: rgb(55 65 81) !important;
                    border-color: rgb(75 85 99) !important;
                    color: white !important;
                }

                .rs-picker-popup-daterange,
                .rs-picker-daterange-panel,
                .rs-calendar,
                .rs-calendar-time-dropdown,
                .rs-calendar-time-dropdown-content,
                .rs-calendar-time-dropdown-column {
                    background-color: rgb(55 65 81) !important;
                }

                .rs-calendar-time-dropdown-column-title {
                    background-color: rgb(55 65 81) !important;
                    color: white !important;
                    border-bottom-color: rgb(75 85 99) !important;
                }

                .rs-calendar-time-dropdown-cell {
                    color: white !important;
                }

                .rs-calendar-time-dropdown-cell:hover {
                    background-color: rgb(75 85 99) !important;
                }

                .rs-calendar-time-dropdown-cell-active {
                    background-color: rgb(59 130 246) !important;
                }

                .rs-picker-toolbar {
                    background-color: rgb(55 65 81) !important;
                    border-top-color: rgb(75 85 99) !important;
                }
            }
        `;
        
        style.id = 'timerange-picker-dark-styles';
        
        const existingStyle = document.getElementById('timerange-picker-dark-styles');
        if (existingStyle) {
            document.head.removeChild(existingStyle);
        }
        
        document.head.appendChild(style);

        return () => {
            const styleToRemove = document.getElementById('timerange-picker-dark-styles');
            if (styleToRemove) {
                document.head.removeChild(styleToRemove);
            }
        };
    }, []);

    const handleTimeChange = (dateRange: [Date, Date] | null) => {
        if (onChange) {
            if (dateRange) {
                const startTime = dateRange[0].toISOString();
                const endTime = dateRange[1].toISOString();
                onChange(startTime, endTime);
            } else {
                onChange(null, null);
            }
        }
    };

    const dateValue: [Date, Date] | null = value && value[0] && value[1] 
        ? [new Date(value[0]), new Date(value[1])] 
        : null;

    return (
        <div className="w-full">
            <TimeRangePicker
            value={dateValue}
            hideHours={hideHours}
            hideMinutes={hideMinutes}
            onChange={handleTimeChange}
            character=" - "
            size="lg"
            placement="bottomStart"
            container={() => document.body}
            className={`mt-1 block w-full rounded-md border text-sm transition-colors
                ${errors.startHour ? "!border-red-500" : "!border-gray-300"}
                !bg-white !text-gray-900
                dark:!bg-gray-700 dark:!text-white dark:!border-gray-600
            `}
            renderValue={(value, _) => {
                const startDate = new Date(value[0]);
                const endDate = new Date(value[1]);
                const formatTime = (date: Date) => {
                const timeString = date.toTimeString();
                const timePart = timeString.split(' ')[0].substring(0, 5); // HH:MM
                const offsetMinutes = date.getTimezoneOffset();
                const offsetHours = Math.abs(offsetMinutes) / 60;
                const offsetSign = offsetMinutes <= 0 ? '+' : '-';
                const offsetString = `GMT${offsetSign}${Math.floor(offsetHours)}`;
                return `${timePart} ${offsetString}`;
                };
                return `${formatTime(startDate)} - ${formatTime(endDate)}`;
            }}
            format="HH:mm"
            />
        </div>
    );
};

export default TimeRangePickerWrapper;